module.exports = __webpack_public_path__ + "img/FH Clan.41568615.png";